import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { marketService, type MarketDetail } from 'shared/src/api';

export const useMarketDetail = (marketId: number) => {
  return useSuspenseQuery<MarketDetail>({
    queryKey: queryKey.marketDetail(marketId),
    queryFn: () => marketService.getMarketDetail(marketId),
  });
};
